(function () {
  function updateDots(gallery) {
    var dots = gallery.parentElement.querySelectorAll('.card__dot');
    if (!dots.length) return;
    var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  function updateArrows(gallery) {
    var media = gallery.closest('.card__media--gallery');
    if (!media) return;
    var prev = media.querySelector('.card__gallery-arrow--prev');
    var next = media.querySelector('.card__gallery-arrow--next');
    if (!prev || !next) return;
    var max = gallery.scrollWidth - gallery.clientWidth - 1;
    prev.disabled = gallery.scrollLeft <= 0;
    next.disabled = gallery.scrollLeft >= max;
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var gallery = event.target;
      if (gallery && gallery.classList && gallery.classList.contains('card__gallery')) {
        updateDots(gallery);
        updateArrows(gallery);
      }
    },
    { capture: true, passive: true }
  );

  if (!window.__cardGalleryArrowsBound) {
    window.__cardGalleryArrowsBound = true;
    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('.card__gallery-arrow');
      if (!arrow) return;
      var media = arrow.closest('.card__media--gallery');
      var gallery = media && media.querySelector('.card__gallery');
      if (!gallery) return;
      event.preventDefault();
      event.stopPropagation();
      var dir = arrow.classList.contains('card__gallery-arrow--next') ? 1 : -1;
      gallery.scrollBy({ left: dir * gallery.clientWidth, behavior: 'smooth' });
    });
  }

  document.querySelectorAll('.card__gallery').forEach(updateArrows);
})();
